module.exports = __webpack_public_path__ + "media/game-over.69319421.mp3";